import LocomotiveScroll from "locomotive-scroll"

export default {
  data() {
    return {
      smoothScroller: null,
      scrollerInitiated: false,
      scrollerObserved: false,
      resizeObserver: null
    }
  },
  methods: {
    initSmoothScroller() {
      this.smoothScroller = new LocomotiveScroll({
        el: document.querySelector("[data-scroll-container]"),
        smooth: true,
        scrollFromAnywhere: true,
        smartphone: {
          smooth: true
        },
        tablet: {
          smooth: true,
          // breakpoint: 991
        },
        reloadOnContextChange: true
      })

      this.scrollerInitiated = true
    },
    scrollToTop(callback) {
      this.smoothScroller.scrollTo("top", {
        duration: 250,
        callback: callback,
        disableLerp: false
      })
    }
  },
  created() {
    const self = this

    if (!this.isDevice && !this.isIOS) {
      this.resizeObserver = new ResizeObserver(function (entries) {
        if (!self.smoothScroller) {
          self.initSmoothScroller()
        } else {
          self.smoothScroller.update()
        }
      })
    }
  },
  mounted() {
    if (document.querySelector("[data-scroll-container]") && !this.isDevice && !this.isIOS) {
      this.resizeObserver.observe(document.querySelector("[data-scroll-container]"))
      this.scrollerObserved = true
    }
  },
  beforeUpdate() {
    if (this.scrollerObserved) {
      this.resizeObserver.unobserve(document.querySelector("[data-scroll-container]"))
      this.scrollerObserved = false
    }
  },
  updated() {
    if (document.querySelector("[data-scroll-container]") && !this.isDevice && !this.isIOS) {
      if (!this.smoothScroller) {
        this.initSmoothScroller()
      }

      this.resizeObserver.observe(document.querySelector("[data-scroll-container]"))

      this.scrollerObserved = true
    }
  }
}